import React from "react";
import { Redirect } from "react-router-dom";
import useRoutePrefix from "../../hooks/useRoutePrefix";
const RedirectHome = () => {
    const { getByRoute } = useRoutePrefix();
    return (<Redirect to={getByRoute()}/>);
};
export default RedirectHome;
